import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import useConfigurationSummary from "../../../../../../hooks/hooks/use-configuration-summary.js";
import { ConfigurationTotalPrice } from "../../../../../ConfigurationTotalPrice/components/ConfigurationTotalPrice/ConfigurationTotalPrice.js";
const ConfigurationTotalPriceContainer = () => {
  const isPhone = MediaQuery.useIsPhone();
  const { bundlePrice, totalPricePrefix } = useConfigurationSummary({ location: "mobile" });
  if (!bundlePrice || !bundlePrice.originalPrice) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ConfigurationTotalPrice,
    {
      centAmount: true,
      size: isPhone ? "medium" : "large",
      ...bundlePrice,
      pricePrefix: totalPricePrefix
    }
  );
};
export {
  ConfigurationTotalPriceContainer
};
//# sourceMappingURL=ConfigurationTotalPriceContainer.js.map
